import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b7b1c77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "holder" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = { class: "lang" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

import InlineSvg from 'vue-inline-svg'
import { useRouter } from 'vue-router'
import useHotkey, { HotKey } from 'vue3-hotkey'
import { computed, inject, onMounted, onUnmounted, ref } from 'vue'

import { useStore } from '@/store'
import close from '@/assets/close.svg'
import BoxTransition from '@/components/BoxTransition.vue'
import { useContent } from '@/composables/content'


export default /*#__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {

const router = useRouter()
const store = useStore()

const { pages } = useContent()
const subpages = computed(() => {
  return pages.value.filter((page) => !page.is_startpage)
})

const nav = (to: string) => {
  store.toggleMenu()
  router.push(to)
}

const hotkeys = ref<HotKey[]>([
  {
    keys: ['esc'],
    preventDefault: true,
    handler(_keys) {
      if (store.menuOpened) store.toggleMenu()
    },
  },
])
const stop = useHotkey(hotkeys.value)

const prevent = () => {
  if (store.menuOpened) {
    store.preventBack = true
    store.toggleMenu()
  }
}

const emitter = inject('emitter')
onMounted(() => {
  addEventListener('popstate', prevent)
})

onUnmounted(() => {
  removeEventListener('popstate', prevent)
})

return (_ctx: any,_cache: any) => {
  const _component_IonButton = _resolveComponent("IonButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BoxTransition, null, {
      default: _withCtx(() => [
        (_unref(store).menuInverted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_IonButton, {
                shape: "round",
                color: "primary",
                fill: "outline",
                class: "btn-tickets",
                href: _unref(store).config.tickets
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(store).language === 'en' ? 'TICKETS' : 'LÍSTKY'), 1)
                ]),
                _: 1
              }, 8, ["href"]),
              _createVNode(_component_IonButton, {
                shape: "round",
                color: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).toggleMenu()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("MENU")
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_IonButton, {
                shape: "round",
                color: "secondary",
                fill: "outline",
                class: "btn-tickets",
                href: _unref(store).config.tickets
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(store).language === 'en' ? 'TICKETS' : 'LÍSTKY'), 1)
                ]),
                _: 1
              }, 8, ["href"]),
              _createVNode(_component_IonButton, {
                shape: "round",
                color: "secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).toggleMenu()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("MENU")
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["sidebar", { 'is-opened': _unref(store).menuOpened, 'is-inverted': _unref(store).menuInverted }])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(InlineSvg), {
          src: _unref(close),
          class: "close",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).toggleMenu()))
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_IonButton, {
              size: "large",
              fill: "clear",
              class: _normalizeClass({ 'is-active': _unref(store).language === 'sk' }),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).loadStories('sk', true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("SK")
              ]),
              _: 1
            }, 8, ["class"]),
            _createTextVNode(" / "),
            _createVNode(_component_IonButton, {
              size: "large",
              fill: "clear",
              class: _normalizeClass({ 'is-active': _unref(store).language === 'en' }),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(store).loadStories('en', true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("EN")
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("ul", null, [
            (_unref(store).config.tickets)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createVNode(_component_IonButton, {
                    color: "secondary",
                    size: "large",
                    fill: "clear",
                    class: "tickets",
                    href: _unref(store).config.tickets
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(store).language === 'en' ? 'I want tickets!' : 'Chcem lístky!'), 1)
                    ]),
                    _: 1
                  }, 8, ["href"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createVNode(_component_IonButton, {
                color: "secondary",
                size: "large",
                fill: "clear",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (nav('/artists')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Artists")
                ]),
                _: 1
              })
            ]),
            (_unref(store).config.schedule)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createVNode(_component_IonButton, {
                    color: "secondary",
                    size: "large",
                    fill: "clear",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (nav('/schedule')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Lineup")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(store).config.map)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _createVNode(_component_IonButton, {
                    color: "secondary",
                    size: "large",
                    fill: "clear",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (nav('/map')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Mapa")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subpages), (page, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, [
                _createVNode(_component_IonButton, {
                  color: "secondary",
                  size: "large",
                  fill: "clear",
                  onClick: ($event: any) => (nav(page.link))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(page.title), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128)),
            _createElementVNode("li", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).config.socials, (item, i) => {
                return (_openBlock(), _createBlock(_component_IonButton, {
                  key: i,
                  size: "small",
                  fill: "clear",
                  href: item.link
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.icon), 1)
                  ]),
                  _: 2
                }, 1032, ["href"]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})